"use client"

import { useCallback } from "react"
import { ImageCard } from "./image-card"

interface SingleImageUploadProps {
	value: string
	onChange: (value: string) => void
	onWorkHistorySelect?: () => Promise<string[]>
}

export function SingleImageUpload({ value, onChange, onWorkHistorySelect }: SingleImageUploadProps) {
	const handleWorkHistorySelect = useCallback(async () => {
		if (!onWorkHistorySelect) return

		try {
			const selectedImages = await onWorkHistorySelect()
			if (selectedImages.length > 0) {
				onChange(selectedImages[0] as string)
			}
		} catch (error) {
			console.error("Failed to select image from work history:", error)
		}
	}, [onWorkHistorySelect, onChange])

	return <ImageCard value={value} onChange={onChange} onWorkHistorySelect={onWorkHistorySelect ? handleWorkHistorySelect : undefined} label="Start image" />
}
